import {
  AddSkillToLessonOperationRequest,
  AddSkillToLessonRequest,
} from "@revolutionrobotics/admin-api";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { LessonApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { FormItem } from "../FormItem";

interface NewLessonsFromProps {
  id: string;
  setError: Function;
  refresh: Function;
}

export function AddSkillToLesson({
  id,
  setError,
  refresh,
}: NewLessonsFromProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (!inputs || !inputs.skillId) return;

    const details: AddSkillToLessonRequest = {
      skillId: inputs.skillId,
    };
    const req: AddSkillToLessonOperationRequest = {
      id: id,
      request: details,
    };

    LessonApi.addSkillToLesson(req).then(
      () => {
        console.log("lesson has been updated.");
        refresh();
      },
      (error) => {
        SetError(error, setError);
      }
    );
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    const name = event.target.name;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row>
            <FormItem
              title={"Epic Id"}
              type={"text"}
              required={true}
              name={"skillId"}
              handleChange={handleChange}
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
